import List from "@/components/list";
import vue from "@/main.js";
const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  function handleDelete(vo) {
    vue.$emit("deleteVideoSet", vo.$index);
  }
  const Deal = ({ props: { vo } }) => {
    const dealConf = [["icon-delete", "删除", () => handleDelete(vo), ""]];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "视频名称",
      prop: "videoName"
    },
    {
      label: "讲师",
      prop: "lecturerName"
    },
    {
      label: "状态",
      prop: "onlineStatusName"
    },
    {
      label: "审核状态",
      prop: "videoAuditStatusName"
    },
    {
      label: "操作",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
